import http from "../utils/http";
import { toast } from "react-toastify";
import { store } from "../store";
import { removeLoader, setLoader } from "../redux/actions/loader";

export const get_partner_by_vat = async (documento, oferta_id = null) => {
  try {
    store.dispatch(setLoader("Buscando cliente"));
    const params = { documento };
    if (oferta_id) {
      params.oferta_id = oferta_id;
    }
    const res = await http.get(`/erp/partner`, { params });
    if (res.data?.warning) {
      toast.warning(res.data.warning, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    return res.data.partner;
  } catch (err) {
    toast.error("Error. El cliente no existe.", {
      position: toast.POSITION.TOP_CENTER,
    });
  } finally {
    store.dispatch(removeLoader());
  }
};

export const get_partner_by_vat_with_warning = async (documento, oferta_id = null) => {
  try {
    store.dispatch(setLoader("Buscando cliente"));
    const params = { documento };
    if (oferta_id) {
      params.oferta_id = oferta_id;
    }
    const res = await http.get(`/erp/partner`, { params });
    return {
      partner: res.data?.partner || null,
      warning: res.data?.warning || null,
    };
  } catch (err) {
    // 404 means the partner simply doesn't exist yet (e.g. new client) — not an error.
    if (err.response?.status !== 404) {
      toast.error("Error al buscar el cliente.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    return { partner: null, warning: null };
  } finally {
    store.dispatch(removeLoader());
  }
};

export const get_partner_by_id = async (partner_id) => {
  try {
    store.dispatch(setLoader("Buscando cliente"));
    const res = await http.get(`/erp/partner`, { params: { partner_id } });
    return res.data.partner;
  } catch (err) {
    // Handle 404 silently - this is expected when partner doesn't exist
    if (err.response?.status === 404) {
      console.warn(`Partner ${partner_id} not found in ERP`);
      return null;
    }
    // Show error for unexpected failures
    toast.error("Error al cargar los datos del cliente.", {
      position: toast.POSITION.TOP_CENTER,
    });
    return null;
  } finally {
    store.dispatch(removeLoader());
  }
};

export const find_or_create_partner = async (datos) => {
  try {
    store.dispatch(setLoader("Creando cliente"));
    const res = await http.post(`/erp/partner`, datos);
    if (res.data?.warning) {
      toast.warning(res.data.warning, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    return res.data.partner;
  } catch (err) {
    toast.error("Error al crear cliente.", {
      position: toast.POSITION.TOP_CENTER,
    });
  } finally {
    store.dispatch(removeLoader());
  }
};

export const set_partner_erp = async (partner_id, datos) => {
  const body = { partner_id, datos };
  try {
    store.dispatch(setLoader("Guardando cliente"));
    const res = await http.put(`/erp/partner`, body);
    return res.data.partner;
  } catch (err) {
    toast.error("Error al modificar cliente.", {
      position: toast.POSITION.TOP_CENTER,
    });
  } finally {
    store.dispatch(removeLoader());
  }
};
